import { gql } from '../__generated__/gql';

gql(`
    fragment LocationParts on LocationType {
        id
        name
        webBookingShowCreditCardStep
        region { id timezone }
    }
`);

export const GET_REGION_LOCATIONS = gql(`
    query GetRegionLocations($id: ID!) {
        locations(filters: { id: { exact: $id } }) {
            id
            region {
                id
                locationSet(filters: { isActive: true, comingSoon: false }) {
                    ...LocationParts
                }
            }
        }
    }
`);

export const GET_AVAILABLE_SLOTS = gql(`
    query GetAvailableSlots($locationId: ID!, $startGte: DateTime!, $endLte: DateTime!) {
        slots(
            filters: {
                location: { id: { exact: $locationId } }
                start: { gte: $startGte }
                end: { lte: $endLte }
                appointmentType: { exact: STANDARD }
                appointment: { id: { isNull: true } }
                published: true
                isDropOff: false
            }
            order: { start: ASC }
        ) {
            id
            start
            end
            staff {
                id
            }
            location {
                ...LocationParts
            }
        }
    }
`);
